import { getLocalizedText } from 'ppbl/utils/locale-helper'
import serverData from 'ppbl/utils/server-data'

export const generateProps = (page) => {
  const isLandingPage = () => {
    return page === 'landingPage' ? true : false
  }

  const isPPBL = () => {
    const product = serverData?.startParams?.product
    if (product && (product === 'paypal' || product === 'paypal-renewal')) {
      return true
    }
    return false
  }

  const logo = {
    text: getLocalizedText('footer.logoText'),
    href: getLocalizedText('footer.logoHref'),
    imageUrl: getLocalizedText('footer.logoImageUrl'),
  }

  const country = {
    flag: {
      text: getLocalizedText('footer.flagText'),
      href: getLocalizedText('footer.flagHref'),
      locale: getLocalizedText('footer.flagLocale'),
    },
  }

  const mainLinks = {
    list: [
      {
        id: 'mainLink_1',
        text: getLocalizedText('footer.mainLinksText1'),
        href: getLocalizedText('footer.mainLinksHref1'),
      },
      {
        id: 'mainLink_2',
        text: getLocalizedText('footer.mainLinksText2'),
        href: getLocalizedText('footer.mainLinksHref2'),
      },
      {
        id: 'mainLink_3',
        text: getLocalizedText('footer.mainLinksText3'),
        href: getLocalizedText('footer.mainLinksHref3'),
      },
      {
        id: 'mainLink_4',
        text: getLocalizedText('footer.mainLinksText4'),
        href: getLocalizedText('footer.mainLinksHref4'),
      },
      {
        id: 'mainLink_5',
        text: getLocalizedText('footer.mainLinksText5'),
        href: getLocalizedText('footer.mainLinksHref5'),
      },
      {
        id: 'mainLink_6',
        text: getLocalizedText('footer.mainLinksText6'),
        href: getLocalizedText('footer.mainLinksHref6'),
      },
      {
        id: 'mainLink_7',
        text: getLocalizedText('footer.mainLinksText7'),
        href: getLocalizedText('footer.mainLinksHref7'),
      },
      {
        id: 'mainLink_8',
        text: getLocalizedText('footer.mainLinksText8'),
        href: getLocalizedText('footer.mainLinksHref8'),
      },
    ],
  }

  if (!isPPBL()) {
    mainLinks.list.push(
      {
        id: 'mainLink_9',
        text: getLocalizedText('footer.mainLinksText9'),
        href: getLocalizedText('footer.mainLinksHref9'),
      },
      {
        id: 'mainLink_10',
        text: getLocalizedText('footer.mainLinksText10'),
        href: getLocalizedText('footer.mainLinksHref10'),
      },
    )
  }

  const secondaryLinks = {
    list: [
      {
        id: 'secondaryLink_1',
        text: getLocalizedText('footer.secondaryLinksText1'),
        href: getLocalizedText('footer.secondaryLinksHref1'),
      },
      {
        id: 'secondaryLink_2',
        text: getLocalizedText('footer.secondaryLinksText2'),
        href: getLocalizedText('footer.secondaryLinksHref2'),
      },
      {
        id: 'secondaryLink_3',
        text: getLocalizedText('footer.secondaryLinksText3'),
        href: getLocalizedText('footer.secondaryLinksHref3'),
      },
      {
        id: 'secondaryLink_4',
        text: getLocalizedText('footer.secondaryLinksText4'),
        href: getLocalizedText('footer.secondaryLinksHref4'),
      },
      {
        id: 'secondaryLink_5',
        text: getLocalizedText('footer.secondaryLinksText5'),
        href: getLocalizedText('footer.secondaryLinksHref5'),
      },
      {
        id: 'secondaryLink_6',
        text: getLocalizedText('footer.secondaryLinksText6'),
        href: getLocalizedText('footer.secondaryLinksHref6'),
      },
    ],
  }

  const tertiaryLinks = {
    list: [
      {
        id: 'tertiaryLink_1',
        text: getLocalizedText('footer.tertiaryLinksText1'),
      },
      {
        id: 'tertiaryLink_2',
        text: getLocalizedText('footer.tertiaryLinksText2'),
        href: getLocalizedText('footer.tertiaryLinksHref2'),
      },
      {
        id: 'tertiaryLink_3',
        text: getLocalizedText('footer.tertiaryLinksText3'),
        href: getLocalizedText('footer.tertiaryLinksHref3'),
      },
      {
        id: 'tertiaryLink_4',
        text: getLocalizedText('footer.tertiaryLinksText4'),
        href: getLocalizedText('footer.tertiaryLinksHref4'),
      },
      {
        id: 'tertiaryLink_5',
        text: getLocalizedText('footer.tertiaryLinksText5'),
        href: getLocalizedText('footer.tertiaryLinksHref5'),
      },
    ],
  }

  const footerDisclaimers = [
    {
      id: 'disclaimer1',
      value: isPPBL()
        ? getLocalizedText('footer.footerNote1PPBL')
        : getLocalizedText('footer.footerNote1LB'),
    },
    {
      id: 'disclaimer2',
      superscript: isLandingPage() ? null : '*',
      value: isLandingPage()
        ? getLocalizedText('footer.footerNote2LandingPage')
        : getLocalizedText('footer.footerNote2'),
    },
  ]

  return {
    mainLinks,
    secondaryLinks,
    tertiaryLinks,
    footerDisclaimers,
    country,
    logo,
  }
}
